var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIconYes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.8660001,15.0375996 C10.6420001,15.0375996 10.4340001,14.9487996 10.2820001,14.7895996 L8.21000004,12.6103997 C7.90600003,12.2903997 7.91400003,11.7839997 8.23400004,11.4799997 C8.55400005,11.1751997 9.05800006,11.1863997 9.37000007,11.5071997 L10.8180001,13.0311996 L14.8260002,8.14719983 C15.1060002,7.80719984 15.6100002,7.75519984 15.9460003,8.03519983 C16.2900003,8.31599982 16.3380003,8.8199998 16.0580003,9.16159979 L11.4820001,14.7455996 C11.3380001,14.9223996 11.1220001,15.0287996 10.8900001,15.0375996 L10.8660001,15.0375996 M11.8180002,4.00000005 C9.73000019,4.00000005 7.76200014,4.81360007 6.2900001,6.28960011 C3.24200002,9.33920019 3.24200002,14.3016003 6.2900001,17.3520004 C7.76200014,18.8288004 9.73000019,19.6416005 11.8180002,19.6416005 C13.9060003,19.6416005 15.8740003,18.8280004 17.3460004,17.3504004 C20.4020005,14.3008003 20.4020005,9.33920019 17.3460004,6.28960011 C15.8740003,4.81360007 13.9060003,4.00000005 11.8180002,4.00000005 Z M11.818,21.2415997 C9.29800002,21.2415997 6.93800001,20.2623997 5.15400001,18.4839997 C1.482,14.8095998 1.482,8.83199988 5.15400001,5.15839995 C6.93800001,3.37999998 9.30600002,2.4 11.818,2.4 C14.338,2.4 16.698,3.37999998 18.4820001,5.15839995 C22.1540001,8.83119988 22.1540001,14.8079998 18.4820001,18.4823997 C16.698,20.2615997 14.338,21.2415997 11.818,21.2415997 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fitness-Style",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fitness-Style---Dashboard---Account---Reimbursement-History",
    transform: "translate(-625.000000, -942.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(190.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(0.000000, 339.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(30.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Item",
    transform: "translate(403.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Action/ic_action_Check-Copy-3",
    transform: "translate(0.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "ic_action_Check",
    fill: "#C3D941",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))))));
}
export default __webpack_public_path__ + "static/media/ic-icon-yes.2dbdc049.svg";
export { SvgIcIconYes as ReactComponent };